{
    "watchForFileChanges" : false,
    "baseUrl" : "https://staging-web.inbooma.net",
    "viewportWidth": 1100,
    "viewportHeight": 700,
    "video": false
}
